let cabinetComplaintsShow = document.querySelector(".cabinetPG__complaint--other");
let cabinetResultsShow = document.querySelector(".cabinetPG__resultsEtc");
let cabinetServicesShow = document.querySelector(".cabinetPG__servicesEtc");

if (cabinetComplaintsShow) {
	cabinetComplaintsShow.addEventListener("click", () => {
		cabinetComplaintsShow
			.closest(".cabinetPG__complaintsList")
			.querySelectorAll(".cabinetPG__complaint.hidden")
			.forEach((item) => {
				item.classList.remove("hidden");
			});
		cabinetComplaintsShow.classList.add("hidden");
	});
}

if (cabinetResultsShow) {
	cabinetResultsShow.addEventListener("click", () => {
		cabinetResultsShow
			.closest(".cabinetPG__results")
			.querySelectorAll(".cabinetPG__result.hidden")
			.forEach((item) => {
				item.classList.remove("hidden");
			});
		cabinetResultsShow.classList.add("hidden");
	});
}

if (cabinetServicesShow) {
	cabinetServicesShow.addEventListener("click", () => {
		cabinetServicesShow
			.closest(".cabinetPG__services")
			.querySelectorAll(".cabinetPG__service.hidden")
			.forEach((item) => {
				item.classList.remove("hidden");
			});
		cabinetServicesShow.classList.add("hidden");
	});
}
